import { render } from "./EnumIcon.vue?vue&type=template&id=e975540a&ts=true"
import script from "./EnumIcon.vue?vue&type=script&lang=ts"
export * from "./EnumIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__